var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPopoverArrowDown = function SvgPopoverArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.678 7.585a4 4 0 0 1-4.358 0L.643 0h27.713L16.677 7.585Z",
    fill: "currentColor"
  })));
};

export { SvgPopoverArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDI5IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNi42Nzc5IDcuNTg0ODFDMTUuMzUyOCA4LjQ0NTQ3IDEzLjY0NTMgOC40NDU0NyAxMi4zMjAyIDcuNTg0ODFMMC42NDI2NTUgLTIuNDIyNzNlLTA2TDI4LjM1NTUgMEwxNi42Nzc5IDcuNTg0ODFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";